/* The tier-2 command bar: the board search on the leading edge, with Filters +
   Views grouped at the trailing end of the row. On phones the search fills the row
   and the two icon buttons sit to its right. */
.cmdbar {
	display: flex;
	gap: var(--spacing-2);
	align-items: center;

	/* Search: a compact, fixed field on the leading edge. */
	& > label {
		flex: 0 0 20rem;
	}

	@media (width <= 640px) {
		& > label {
			flex: 1 1 auto;
			min-inline-size: 0;
		}
	}
}

/* Filters + Views, pushed to the trailing end of the row. */
.controls {
	display: flex;
	flex: none;
	gap: var(--spacing-2);
	align-items: center;
	margin-inline-start: auto;
}

/* Shared trigger-button chrome for Filters + Views (imported by both). */
.control {
	display: inline-flex;
	flex: none;
	gap: var(--spacing-1-5);
	align-items: center;
	block-size: var(--control-height-sm);
	padding-inline: var(--spacing-3);
	font-size: var(--font-size-sm);
	font-weight: var(--font-weight-medium);
	color: var(--colour-text-secondary);
	white-space: nowrap;
	cursor: pointer;
	background-color: var(--colour-background-surface);
	border: 1px solid var(--colour-border-subtle);
	border-radius: var(--radius-md);
	transition:
		color var(--motion-fast) var(--ease-standard),
		border-color var(--motion-fast) var(--ease-standard);

	& svg {
		flex: none;
		opacity: 0.85;
	}

	&:hover {
		color: var(--colour-text-primary);
		border-color: var(--colour-border-strong);
	}
}

/* Active when any field filter is set (or grouping is on). */
.controlActive {
	color: var(--colour-text-primary);
	border-color: var(--colour-brand-primary);
}

/* The control's text label — hidden on phones, leaving the icon. */
@media (width <= 640px) {
	.controlLabel {
		display: none;
	}
}

/* Count of active filter fields. */
.badge {
	display: inline-grid;
	place-items: center;
	min-inline-size: 1.05rem;
	block-size: 1.05rem;
	padding-inline: var(--spacing-1);
	font-size: var(--font-size-xs);
	font-weight: var(--font-weight-bold);
	color: var(--colour-text-on-brand);
	background-color: var(--colour-brand-primary);
	border-radius: var(--radius-full);
}
